export default "__VITE_ASSET__7e078d58__"